export const mapToTreeFromData = (item: any) => ({
  title: item.name,
  key: item.id,
  children: item.items && item.items.map(mapToTreeFromData),
});